/* Copyright (c) 2020-present CloudIO Inc */

import { FieldType } from '@cloudio-saas/datasource-types';

export const FieldTypeIcons: Record<FieldType, string> = {
  Attachment: 'paperclip',
  // Address: 'building',
  // Binary: 'hashtag',
  Boolean: 'check-square',
  // Currency: 'money-bill-alt',
  Date: 'calendar-day',
  DateTime: 'calendar-week',
  StringDateTime: 'calendar-alt',
  ServerDate: 'calendar-alt',
  ServerDateTime: 'calendar-day',
  Decimal: 'io-float-attr:cloudio',
  Double: 'io-float-attr:cloudio',
  Email: 'io-email-attr:cloudio',
  EncryptedString: 'shield-check',
  // Password: 'key',
  Integer: 'io-int-attr:cloudio',
  // IntegerArray: 'list-ol',
  // Location: 'map-marked-alt',
  Percent: 'percent',
  Phone: 'phone',
  Reference: 'external-link',
  String: 'text',
  // StringArray: 'clipboard-list-check',
  Textarea: 'comment-alt-lines',
  // Time: 'clock',
  URL: 'io-url-attr:cloudio',
  UserID: 'user',
  YN: 'check-circle',
  TF: 'check-circle',
  JSON: 'brackets-curly',
} as const;
